<style scoped>
  .search-item{
    display: inline-block;
    float: left;
    margin-left: 10px;
  }

  .search-item span{
    line-height: 32px;
    display: inline-block;
  }

</style>

<template>
  <div>
    <div v-if="searchable" class="search-con">
      <Form ref="searchForm" :model="searchValue"  style="display: inline-block; width: 100%">
        <div class="search-item">
          <span>文章标题:&nbsp;</span>
          <Input v-model="searchValue.title" clearable  placeholder="" style="width: 100px; float: right"></Input>
        </div>
        <div class="search-item">
          <span>作者:&nbsp;</span>
          <Input v-model="searchValue.author" clearable  placeholder="" style="width: 100px; float: right"></Input>
        </div>
        <div class="search-item">
          <span>专辑:&nbsp;</span>
          <Select v-model="searchValue.albumId" placeholder="请选择" clearable  style="width: 100px; float: right">
            <Option v-for="item in backAlbumList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="search-item">
          <span>发布平台:&nbsp;</span>
          <Select v-model="publicPlat"
                  placeholder="请选择"
                  clearable
                  style="width: 100px; float: right"
                  @on-change="platChange"
                  @on-clear="platClear">
            <Option v-for="item in platList" :value="item.value" :key="item.name">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="search-item">
          <span>更新时间:&nbsp;</span>
          <DatePicker
            type="datetimerange"
            placeholder="开始时间-结束时间"
            clearable
            v-model="checkedTime"
            style="width: 300px; float: right;"
            @on-change="dateTimeChange"
            @on-clear="dateTimeClear"
          ></DatePicker>
        </div>
        <FormItem style="display: inline-block;float: right">
          <Button type="primary" @click="handleSubmit">查询</Button>
          <Button @click="handleReset" style="margin-left: 8px">重置</Button>
          <Dropdown  trigger="click">
            <Button style="margin-left: 8px">
              更多操作
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="addBackAlbum">新建专辑</DropdownItem>
              <DropdownItem @click.native="updateBackAlbum">编辑专辑</DropdownItem>
              <DropdownItem @click.native="deleteBackAlbum">删除专辑</DropdownItem>
              <DropdownItem @click.native="updateData">同步</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </FormItem>
      </Form>
    </div>
    <Table
      ref="tablesMain"
      :data="insideTableData"
      :columns="insideColumns"
      :stripe="stripe"
      :border="border"
      :show-header="showHeader"
      :width="width"
      :height="height"
      :loading="loading"
      :disabled-hover="disabledHover"
      :highlight-row="highlightRow"
      :row-class-name="rowClassName"
      :size="size"
      :no-data-text="noDataText"
      :no-filtered-data-text="noFilteredDataText"
      @on-current-change="onCurrentChange"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
      @on-selection-change="onSelectionChange"
      @on-sort-change="onSortChange"
      @on-filter-change="onFilterChange"
      @on-row-click="onRowClick"
      @on-row-dblclick="onRowDblclick"
      @on-expand="onExpand"
    >
      <slot name="header" slot="header"></slot>
      <slot name="footer" slot="footer"></slot>
      <slot name="loading" slot="loading"></slot>
    </Table>
    <div style="margin: 10px;overflow: hidden">
      <div v-if="showDelete" style="float: left;">
        <Button type="error" @click="">删除</Button>
      </div>
      <div style="float: right;">
        <Page
          :total="insidePageTotal"
          :current="insideCurrPage"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          show-sizer show-elevator show-total>
        </Page>
      </div>
    </div>
    <Modal v-model="otherHandle" :closable="false" :mask-closable="false" width="450px">
      <Form ref="albumInput" :model="albumInput" :rules="ruleValidate">
        <FormItem v-if="isAddAlbum" prop="newAlbum" label="请输入新建专辑名称：" style="display: inline">
          <Input v-model="albumInput.newAlbum" placeholder="请输入" clearable style="width: 240px"></Input>
        </FormItem>
        <FormItem v-if="isUpdateAlbum" prop="album" label="请选择要修改的专辑名：" style="display: inline">
          <Select v-model="albumInput.albumId" placeholder="请选择"  style="width: 180px; float: left">
            <Option v-for="item in backAlbumList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <br><br>
          <span style="margin-left: 94px">修改为：</span>
          <Input v-model="albumInput.album" placeholder="请输入" clearable style="width: 180px; margin-left: 9px"></Input>
        </FormItem>
        <FormItem v-if="isDeleteAlbum" prop="albumIds" label="请选择要删除的专辑：" style="display: inline">
          <Select v-model="albumInput.albumIds" placeholder="请选择" multiple  style="float: left">
            <Option v-for="item in backAlbumList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button size="large" @click="cancelHandle">取消</Button>
        <Button type="primary" size="large" :loading="creatLoading" @click="saveHandle">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import TablesEdit from './edit.vue';
import './index.less';
import {format2Sec} from "../../utils/format";
export default {
  name: 'Tables',
  props: {
    value: {
      type: Array,
      default () {
        return [];
      }
    },
    columns: {
      type: Array,
      default () {
        return [];
      }
    },
    albumList: {
      type: Array,
      default () {
        return [];
      }
    },
    currPage: Number,
    pageSize: Number,
    pageTotal: Number,
    appName: String,
    size: String,
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default () {
        return '';
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * @description 全局设置是否可编辑
     */
    editable: {
      type: Boolean,
      default: false
    },
    /**
     * @description 是否可搜索
     */
    searchable: {
      type: Boolean,
      default: false
    },
  },
  /**
   * Events
   * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
   * @on-cancel-edit 返回值 {Object} 同上
   * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
   */
  data () {
    return {
      checkedTime: [],
      publicPlat: '',
      platList: [
          {
              name: '小程序',
              value: 'miniappPublic'
          },
          {
              name: '官网',
              value: 'websitePublic'
          },
          {
              name: 'APP',
              value: 'appPublic'
          }
      ],
      currAppName: '',
      pageResultVo: {},
      insideCurrPage: 1,
      insidePageSize: 10,
      insidePageTotal: 0,
      insideColumns: [],
      insideTableData: [],
      edittingCellId: '',
      edittingText: '',
      searchValue: {},  //查询数据
      showDelete: false,
      otherHandle: false, //控制其他操作弹窗
      isAddAlbum: false,  //控制新增专辑弹窗
      isUpdateAlbum: false,
      isDeleteAlbum: false,
      creatLoading: false,
      backAlbumList: [],  //获取所有专辑列表
      albumInput: {},   //专辑编辑表单
      ruleValidate: {
        newAlbum: [
          { required: true, message: '专辑名不能为空', trigger: 'blur' },
          { type: 'string', max: 10, message: '不能超过10个字符', trigger: 'blur' },
        ],
        album: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { type: 'string', max: 10, message: '不能超过10个字符', trigger: 'blur' },
        ]
      }
    };
  },
  methods: {
    handleColumns (columns) {
      this.insideColumns = columns.map((item, index) => {
        let res = item;
        if (res.editable) res = this.suportEdit(res, index);
        if (res.key === 'handle') res = this.surportHandle(res);
        return res;
      });
    },
    handleTableData () {
      this.insidePageTotal = this.pageTotal;
      this.insideCurrPage = this.currPage;
      this.insidePageTotal = this.pageTotal;
      this.backAlbumList = this.albumList;
      this.currAppName = this.appName;
      this.insideTableData = this.value.map((item, index) => {
        let res = item;
        res.initRowIndex = index;
        return res;
      });
    },
    handleSubmit () {
        this.pageResultVo = {};
        this.searchValue.appName = this.currAppName;
        this.pageResultVo.content = this.searchValue;
        this.pageResultVo.currPage = 0;
        this.pageResultVo.pageSize = this.insidePageSize;
        console.log(this.pageResultVo);
        this.getInsideTableData();
    },
    handleReset () {
      this.searchValue = {};
      this.publicPlat = null;
      this.checkedTime = null;
    },

    suportEdit (item, index) {
      item.render = (h, params) => {
        return h(TablesEdit, {
          props: {
            params: params,
            value: this.insideTableData[params.index][params.column.key],
            edittingCellId: this.edittingCellId,
            editable: this.editable,
            albumList: this.backAlbumList
          },
          on: {
            'input': val => {
              this.edittingText = '';
              this.edittingText = val;
            },
            'on-start-edit': (params) => {
              this.edittingCellId = `editting-${params.index}-${params.column.key}`;
              this.$emit('on-start-edit', params);
            },
            'on-cancel-edit': (params) => {
              this.edittingCellId = '';
              this.$emit('on-cancel-edit', params);
            },
            'on-save-edit': (params) => {
              let obj = {};
              let tempArr = this.insideTableData;
              this.insideTableData = [];
              if (this.edittingText !== ''){
                obj.id = params.row.id;
                obj.index = params.row.initRowIndex;
                if (params.column.key === 'album') {
                  obj.albumId = this.edittingText;
                  params.row[params.column.key] = this.getAlbumName(this.edittingText);
                } else {
                  obj[params.column.key] = this.edittingText;
                  params.row[params.column.key] = this.edittingText;
                }
              }
              this.setBackMaterial(obj);
              tempArr[params.index] = params.row;
              this.insideTableData = tempArr;
              this.edittingCellId = '';
            },
            'on-save-modal': (params) => {
                this.setBackMaterial(params.row);
                let tempArr = this.insideTableData;
                this.insideTableData = [];
                params.row.album = this.getAlbumName(params.row.albumId);
                tempArr[params.index] = params.row;
                this.insideTableData = tempArr;
            }
          }
        });
      };
      return item;
    },
    getInsideTableData () {
        this.$http.post('/zm/backManage/queryBackMaterialListByPage', this.pageResultVo).then(res => {
                  this.insideCurrPage = res.data.currPage;
                  this.insidePageSize = res.data.pageSize;
                  this.insidePageTotal = res.data.pageTotal;
                  let tempData = res.data.content;
                  tempData.map((item, index) => {
                      let res1 = item;
                      res1.initRowIndex = index;
                      if (res1.updateTime){
                          res1.time = format2Sec(res1.updateTime);
                      }
                      res1.album = this.getAlbumName(res1.albumId);
                      return res1;
                  });
                  this.insideTableData = tempData;
                this.$Message.success('查询成功');
              },
              err => {
                  this.$Message.error("请求失败：" + err.message);
              });
      },
    surportHandle (item) {
      item.render = (h, params) => {
        return h('div', [
          h('Poptip', {
              props: {
                confirm: true,
                title: params.row.miniappPublic === 1?'您确定从小程序上撤下吗？':'您确定要发布到小程序上吗？',
                transfer: true
              },
              on: {
                'on-ok': () => {
                  params.row.miniappPublic = (params.row.miniappPublic + 1)%2;
                  let obj = {};
                  obj.id = params.row.id;
                  obj.miniappPublic = params.row.miniappPublic;
                  this.setBackMaterial(obj);
                },
                'on-cancel': () => {
                }
              }},
            [h('Button', {
              props: {
                size: 'small',
                type: params.row.miniappPublic === 1?'primary':'default'
              },
              style: {
                marginRight: '10px'
              }
            }, '小程序')]
          ),
          h('Poptip', {
              props: {
                confirm: true,
                title: params.row.websitePublic === 1?'您确定从官网上撤下吗？':'您确定要发布到官网上吗？',
                transfer: true
              },
              on: {
                'on-ok': () => {
                  params.row.websitePublic = (params.row.websitePublic + 1)%2;
                  let obj = {};
                  obj.id = params.row.id;
                  obj.websitePublic = params.row.websitePublic;
                  this.setBackMaterial(obj);
                },
                'on-cancel': () => {
                }
              }},
            [h('Button', {
              props: {
                size: 'small',
                type: params.row.websitePublic === 1?'primary':'default'
              },
              style: {
                marginRight: '10px'
              }
            }, '官网')]
          ),
          h('Poptip', {
              props: {
                confirm: true,
                title: params.row.appPublic === 1?'您确定从APP上撤下吗？':'您确定要发布到APP上吗？',
                transfer: true
              },
              on: {
                'on-ok': () => {
                  params.row.appPublic = (params.row.appPublic + 1)%2;
                  let obj = {};
                  obj.id = params.row.id;
                  obj.appPublic = params.row.appPublic;
                  this.setBackMaterial(obj);
                       },
                'on-cancel': () => {
                }
              }},
            [h('Button', {
              props: {
                size: 'small',
                type: params.row.appPublic === 1?'primary':'default'
              },
              style: {
                marginRight: '10px'
              }
            }, 'APP')]
          )
        ]);
      };
      return item;
    },
    changePage (currPage) {
        this.pageResultVo = {};
        this.insideCurrPage = currPage;
        this.pageResultVo.content = {appName : this.currAppName};
        this.pageResultVo.currPage = this.insideCurrPage;
        this.pageResultVo.pageSize = this.insidePageSize;
        this.getInsideTableData();
    },
    changePageSize(pageSize){
        this.pageResultVo = {};
        this.insidePageSize = pageSize;
        this.pageResultVo.content = {appName : this.currAppName};
        this.pageResultVo.currPage = this.insideCurrPage;
        this.pageResultVo.pageSize = this.insidePageSize;
        this.getInsideTableData();
    },
    addBackAlbum () {  //显示新增专辑弹框
      this.albumInput = {};
      this.otherHandle = true;
      this.isAddAlbum = true;
    },
    updateBackAlbum () {
      this.albumInput = {};
      this.otherHandle = true;
      this.isUpdateAlbum = true;
    },
    deleteBackAlbum () {
      this.albumInput = {};
      this.otherHandle = true;
      this.isDeleteAlbum = true;
    },

    saveHandle() {  //执行操作
      this.creatLoading = true;
      setTimeout(() => {
        this.creatLoading = false;
        this.$refs["albumInput"].validate((valid) => {
          if (valid) {
            if (this.isAddAlbum) {
              for (let i=0; i < this.backAlbumList.length; i++) {
                if (this.albumInput.newAlbum === this.backAlbumList[i].name) {
                  this.$Message.error('该专辑名已存在！');
                  return;
                }
              }
              this.$http.post("/zm/backManage/addBackAlbum", {"name": this.albumInput.newAlbum}).then(
                () => {
                  this.$Message.success('操作成功!');
                  this.otherHandle = false;
                  this.isAddAlbum = false;
                  this.getBackAlbumList(); //执行操作后更新专辑列表
                },
                err => {
                  this.$Message.error("操作失败：" + err.message);
                }
              );
            }
            if (this.isUpdateAlbum) {
              for (let i=0; i < this.backAlbumList.length; i++) {
                if (this.albumInput.album === this.backAlbumList[i].name) {
                  this.$Message.error('该专辑名已存在！');
                  return;
                }
              }
              this.$http.post("/zm/backManage/updateBackAlbum",
                {"name": this.albumInput.album,
                  "id": this.albumInput.albumId}).then(
                () => {
                  this.$Message.success('操作成功!');
                  this.otherHandle = false;
                  this.isUpdateAlbum = false;
                  this.getBackAlbumList(); //执行操作后更新专辑列表
                },
                err => {
                  this.$Message.error("操作失败：" + err.message);
                }
              );
            }
            if (this.isDeleteAlbum) {
              this.$http.post("/zm/backManage/deleteBackAlbum", {"backAlbumIds": this.albumInput.albumIds}).then(
                () => {
                  this.$Message.success('操作成功!');
                  this.otherHandle = false;
                  this.isDeleteAlbum = false;
                  this.getBackAlbumList(); //执行操作后更新专辑列表
                },
                err => {
                  this.$Message.error("操作失败：" + err.message);
                }
              );
            }
          } else {
            this.$Message.error('操作失败!');
          }
        });
      }, 1000);
    },
    cancelHandle() {  //取消操作
      this.otherHandle = false;
      this.isAddAlbum = false;
      this.isUpdateAlbum = false;
      this.isDeleteAlbum = false;
    },
    updateData () {
        console.log({"appName": this.currAppName});
      this.$http.post('/zm/backManage/synchroBackMaterial', {"appName": this.currAppName}).then(
        (res) => {
            if (res.data.content === '同步失败'){
                this.$Message.error(res.data.content);
            }else {
                this.$Message.success(res.data.content);
            }
        },
        err => {
          this.$Message.error("请求失败：" + err.message);
        }
      );
    },
    getBackAlbumList () {
      this.$http.post("/zm/backManage/queryAlbumList", {}).then(
        res => {
          this.backAlbumList = res.data.content;
          console.log("获取专辑列表");
        },
        err => {
          this.$Message.error("请求失败：" + err.message);
        }
      );
    },
    getAlbumName (id) {
      let name;
      for (let i = 0; i < this.backAlbumList.length; i++){
        if (id === this.backAlbumList[i].id){
          name = this.backAlbumList[i].name;
          break;
        }else{
            name = '请添加所属专辑';
        }
      }
      return name;
    },
    setBackMaterial (obj) {
      this.$http.post('zm/backManage/updateBackMaterial', obj).then(
        () => {
          this.$Message.success('操作成功!');
        },
        err => {
          this.$Message.error("请求失败：" + err.message);
        }
      );
    },

    handleClear (e) {
      if (e.target.value === '') this.insideTableData = this.value;
    },

    exportCsv (params) {
      this.$refs.tablesMain.exportCsv(params);
    },
    clearCurrentRow () {
      this.$refs.talbesMain.clearCurrentRow();
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow);
    },
    onSelect (selection, row) {
      this.$emit('on-select', selection, row);
    },
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row);
    },
    onSelectAll (selection) {
      this.$emit('on-select-all', selection);
    },
    onSelectAllCancel (selection) {
      this.$emit('on-select-all-cancel', selection);
    },
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection);
      this.showDelete = true;
      if (selection.length === 0) {
        this.showDelete = false;
      }
    },
    onSortChange (column, key, order) {
      this.$emit('on-sort-change', column, key, order);
    },
    onFilterChange (row) {
      this.$emit('on-filter-change', row);
    },
    onRowClick (row, index) {
      this.$emit('on-row-click', row, index);
    },
    onRowDblclick (row, index) {
      this.$emit('on-row-dblclick', row, index);
    },
    onExpand (row, status) {
      this.$emit('on-expand', row, status);
    },
    platChange(value){
        delete this.searchValue['miniappPublic'];
        delete this.searchValue['websitePublic'];
        delete this.searchValue['appPublic'];
        if (value){
            this.searchValue[value] = 1;
        }
    },
    platClear(){
        delete this.searchValue['miniappPublic'];
        delete this.searchValue['websitePublic'];
        delete this.searchValue['appPublic'];
    },
    /**
     * 选择时间
     */
    dateTimeChange(time) {
      if (time[0] !== "") {
        this.searchValue.updateTimeStart = time[0];
        this.searchValue.updateTimeEnd = time[1];
      } else {
        delete this.searchValue["updateTimeStart"];
        delete this.searchValue["updateTimeEnd"];
      }
    },
    /**
     * 清空时间
     */
    dateTimeClear() {
      delete this.searchValue["updateTimeStart"];
      delete this.searchValue["updateTimeEnd"];
    }
  },
  watch: {
    columns (columns) {
      this.handleColumns(columns);
    },
    value (val) {
      this.handleTableData();
    }
  },
  created () {
    this.handleColumns(this.columns);
    this.handleTableData();
  }
};
</script>



// WEBPACK FOOTER //
// tables.vue?2c147800